import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Captcha } from 'primereact/captcha';

import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { useUserDetailsContext } from 'context/userDetailsContext';

export default function ReCapcha() {
  const name = 'recaptcha';
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { userDetails } = useUserDetailsContext();

  return (
    <div className="w-100">
      <Controller
        name={name}
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <Captcha
            theme={userDetails?.appearance_preference === 'dark' ? 'dark' : 'light'}
            siteKey={process.env.REACT_APP_GOOGLE_RECAPCHA}
            onExpire={() => field.onChange(null)}
            onResponse={(response) => field.onChange(response)}
          />
        )}
      />
      <RequiredValidation field={name} errors={errors} message="Captcha Required" />
    </div>
  );
}
